{
  "native": {
    "language": "Español",
    "variant": "España",
    "variantHint": "tú/vosotros",
    "testPhrase": "El clima es muy agradable hoy"
  },
  "auth": {
    "login": {
      "validationError": "Introduce tu correo electrónico y contraseña"
    },
    "signup": {
      "emailError": "Introduce un correo electrónico válido",
      "codeError": "Introduce el código de 6 dígitos del correo",
      "confirmExpiry": "También puedes pulsar el enlace del correo en lugar de escribir el código."
    },
    "forgotPassword": {
      "subtitle": "Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña",
      "emailError": "Introduce un correo electrónico válido",
      "successExpiry": "También puedes pulsar el enlace del correo en lugar de escribir el código.",
      "successRetryLink": "Volver a intentarlo",
      "successRetryAccessibility": "Volver a intentarlo",
      "codeError": "Introduce el código de 6 dígitos del correo"
    }
  },
  "chat": {
    "consent": {
      "providers": {
        "geminiPurpose": "Análisis de conversación y correcciones gramaticales",
        "openaiPurpose": "Análisis de conversación y correcciones gramaticales"
      }
    }
  },
  "profile": {
    "info": {
      "namePlaceholder": "Introduce tu nombre"
    },
    "security": {
      "newPasswordPlaceholder": "Introduce nueva contraseña",
      "confirmPasswordPlaceholder": "Confirma nueva contraseña"
    }
  },
  "errorBoundary": {
    "title": "Algo ha salido mal",
    "message": "Lo sentimos, ha ocurrido algo inesperado. Nuestro equipo fue notificado y estamos trabajando para solucionarlo.",
    "suggestion": "Inténtalo de nuevo más tarde."
  },
  "featureGate": {
    "trialExpiresToday": "¡La prueba caduca hoy!"
  },
  "roleplay": {
    "list": {
      "title": "Simulaciones",
      "sectionYours": "Tus juegos de rol",
      "createCustom": "Crear juego de rol personalizado",
      "slotsFull": "{{cap}}/{{cap}} espacios usados",
      "slotLabel": "{{title}} — {{scenario}}",
      "templateLabel": "{{title}}",
      "loadErrorRetry": "Reintentar"
    },
    "templates": {
      "preview": {
        "title": "Vista previa",
        "sectionVocabulary": "Vocabulario",
        "sectionPhrases": "Frases clave",
        "startButton": "Comenzar este juego de rol",
        "statusNew": "Nueva",
        "statusLearning": "En curso",
        "statusMastered": "Dominada"
      }
    },
    "collections": {
      "sectionTitle": "Colecciones",
      "progress": "{{completed}}/{{total}} hechos",
      "cardLabel": "{{title}}, {{completed}} de {{total}} hechos",
      "searchPlaceholder": "Buscar juegos de rol",
      "searchClear": "Borrar búsqueda",
      "searchEmpty": "Sin coincidencias. Prueba con otra palabra.",
      "emptyHint": "Todavía no hay colecciones disponibles.",
      "difficultyLabel": "Niv. {{level}}",
      "filterDifficultyLabel": "Filtrar por nivel {{level}}",
      "filterCompleted": "Completados",
      "filterUncompleted": "Sin empezar"
    }
  },
  "soundMap": {
    "title": "Mapa de sonidos",
    "loading": "Cargando tu mapa de sonidos...",
    "loadError": "No se pudo cargar tu mapa de sonidos.",
    "progressLabel": "{{mastered}} de {{total}} sonidos dominados",
    "summary": {
      "mastered_one": "{{count}} dominado",
      "mastered_other": "{{count}} dominados",
      "learning_one": "{{count}} en progreso",
      "learning_other": "{{count}} en progreso",
      "weak_one": "{{count}} débil",
      "weak_other": "{{count}} débiles",
      "untried_one": "{{count}} sin practicar",
      "untried_other": "{{count}} sin practicar"
    },
    "sections": {
      "consonants": "Consonantes",
      "vowels": "Vocales",
      "diphthongs": "Diptongos",
      "tones": "Tonos"
    },
    "states": {
      "mastered": "Dominado",
      "learning": "En progreso",
      "weak": "Débil",
      "untried": "Sin practicar"
    },
    "chip": {
      "scoreValue": "{{score}}%",
      "a11yMastered": "{{symbol}}, dominado, {{score}} por ciento",
      "a11yLearning": "{{symbol}}, en progreso, {{score}} por ciento",
      "a11yWeak": "{{symbol}}, débil, {{score}} por ciento",
      "a11yUntried": "{{symbol}}, sin practicar",
      "a11yUntriedHard": "{{symbol}}, sin practicar, suele ser difícil"
    },
    "detail": {
      "exampleWordsTitle": "Palabras de ejemplo",
      "statsAvgScore": "Puntuación promedio",
      "statsAttempts": "Intentos",
      "statsLastPracticed": "Última práctica",
      "notPracticedYet": "Todavía no has practicado este sonido.",
      "difficultyLabel": "Dificultad esperada",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "Este sonido suele ser difícil para hispanohablantes.",
      "tipsTitle": "Consejos",
      "practiceButton": "Practicar este sonido",
      "closeA11y": "Cerrar detalles del sonido"
    },
    "practiceCard": {
      "title": "Mapa de sonidos",
      "subtitle": "Sigue tu dominio de cada sonido",
      "cta": "Abre el mapa de sonidos"
    },
    "guidanceOnly": {
      "summary": "Los sonidos del inglés que más cuestan a quienes hablan español",
      "body": "Estos son los sonidos de tu inglés. Los marcados son los que suelen costar más a quienes hablan español: toca cualquiera para ver consejos y practicarlo con tu tutor."
    }
  },
  "competenceMap": {
    "title": "Mapa de competencias",
    "loading": "Cargando tu mapa de competencias...",
    "loadError": "No se pudo cargar tu mapa de competencias.",
    "progressLabel": "{{mastered}} de {{total}} competencias dominadas",
    "dueTitle": "Para repasar hoy",
    "bandEmpty": "Todavía no hay contenido de este nivel.",
    "bandCount_one": "{{count}} competencia",
    "bandCount_other": "{{count}} competencias",
    "bandLater_one": "{{count}} más adelante",
    "bandLater_other": "{{count}} más adelante",
    "summary": {
      "mastered_one": "{{count}} dominada",
      "mastered_other": "{{count}} dominadas",
      "learning_one": "{{count}} en progreso",
      "learning_other": "{{count}} en progreso",
      "struggling_one": "{{count}} con dificultades",
      "struggling_other": "{{count}} con dificultades",
      "untried_one": "{{count}} sin ver",
      "untried_other": "{{count}} sin ver",
      "upcoming_one": "{{count}} más adelante",
      "upcoming_other": "{{count}} más adelante"
    },
    "bands": {
      "A1": "A1 · Principiante",
      "A2": "A2 · Elemental",
      "B1": "B1 · Intermedio",
      "B2": "B2 · Intermedio alto",
      "C1": "C1 · Avanzado",
      "C2": "C2 · Dominio",
      "any": "En cualquier nivel"
    },
    "states": {
      "mastered": "Dominada",
      "learning": "En progreso",
      "struggling": "Con dificultades",
      "untried": "Sin ver",
      "upcoming": "Más adelante"
    },
    "chip": {
      "due": "Para repasar",
      "a11y": "{{name}}, {{state}}",
      "a11yWithHard": "{{name}}, {{state}}, suele ser difícil"
    },
    "detail": {
      "examplesTitle": "Ejemplos",
      "exampleCorrect": "✓ {{text}}",
      "exampleIncorrect": "✗ {{text}}",
      "statsProductions": "Usos correctos",
      "statsStruggles": "Errores",
      "statsSessions": "Sesiones",
      "statsLastUsed": "Última vez",
      "statsNextReview": "Próximo repaso",
      "notSeenYet": "Todavía no te hemos visto usar esto.",
      "comesLater": "Esto llega más adelante en tu recorrido.",
      "difficultyLabel": "Dificultad esperada",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "Esto suele ser difícil para hispanohablantes.",
      "tipsTitle": "Consejos",
      "practiceButton": "Practicar esto",
      "closeA11y": "Cerrar detalles de la competencia"
    },
    "practiceCard": {
      "title": "Mapa de competencias",
      "subtitle": "Sigue tu dominio de la gramática",
      "cta": "Abre el mapa de competencias"
    }
  },
  "vocabulary": {
    "title": "Tu vocabulario",
    "hubCard": {
      "title": "Tu vocabulario",
      "subtitle": "Palabras y expresiones que practicas",
      "counts": "{{mastered}} dominadas · {{due}} para repasar"
    },
    "counts": {
      "new": "Nuevas",
      "learning": "Aprendiendo",
      "mastered": "Dominadas"
    },
    "due": {
      "title": "Para repasar",
      "empty": "No tienes nada pendiente de repaso. ¡Sigue así!",
      "more": "y {{overflow}} más para repasar"
    },
    "list": {
      "learning": "Aprendiendo",
      "mastered": "Dominadas",
      "empty": "Todavía no hay nada aquí. Prueba una simulación para empezar."
    },
    "error": {
      "retry": "Reintentar"
    }
  },
  "errors": {
    "api": {
      "TIMEOUT": "La solicitud ha tardado demasiado. Inténtalo de nuevo.",
      "VALIDATION_FAILED": "Comprueba los datos introducidos e inténtalo de nuevo.",
      "AI_SERVICE_ERROR": "Error del servicio de IA. Inténtalo de nuevo.",
      "SERVICE_UNAVAILABLE": "Servicio temporalmente no disponible. Inténtalo más tarde.",
      "TOKEN_EXPIRED": "Tu sesión ha caducado. Inicia sesión de nuevo.",
      "INTERNAL_ERROR": "Algo ha salido mal.",
      "DATABASE_ERROR": "Algo ha salido mal.",
      "UNKNOWN": "Algo ha salido mal.",
      "ROLEPLAY_TEMPLATE_NOT_FOUND": "Esta plantilla ya no está disponible."
    },
    "auth": {
      "INVALID_CREDENTIALS": "Correo electrónico o contraseña incorrectos. Inténtalo de nuevo.",
      "EMAIL_NOT_CONFIRMED": "Comprueba tu correo electrónico antes de iniciar sesión. Revisa tu bandeja de entrada para el enlace de confirmación.",
      "USER_ALREADY_EXISTS": "Ya existe una cuenta con este correo electrónico. Inicia sesión.",
      "RATE_LIMITED": "Demasiados intentos. Espera un momento e inténtalo de nuevo.",
      "RESET_LINK_EXPIRED": "El enlace de restablecimiento ha caducado. Solicita uno nuevo.",
      "RECOVERY_CODE_INVALID": "El código no es válido o ha caducado. Solicita uno nuevo.",
      "SIGNUP_CODE_INVALID": "El código no es válido o ha caducado. Solicita uno nuevo.",
      "SESSION_EXPIRED": "Tu sesión ha caducado. Inicia sesión de nuevo."
    }
  },
  "vocabSets": {
    "title": "Conjuntos de palabras",
    "drillTitle": "Práctica",
    "loading": "Cargando…",
    "loadError": "No pudimos cargar los conjuntos.",
    "intro": "Grupos de palabras para practicar directamente. Escribe la palabra en inglés: solo cuenta si la produces tú.",
    "countLabel": "{{done}} de {{total}} dominadas",
    "inputPlaceholder": "Escribe la palabra en inglés",
    "check": "Comprobar",
    "reveal": "Mostrar la respuesta",
    "next": "Siguiente",
    "empty": "Este conjunto todavía no tiene palabras.",
    "markError": "No pudimos guardar tu respuesta. Inténtalo de nuevo.",
    "speak": "Decirlo en voz alta",
    "pronunciationScore": "Pronunciación: {{score}}/100",
    "notHeard": "No te escuchamos bien. Inténtalo otra vez."
  }
}
